import { ReactNode, useMemo } from "react";

import { Column, createRows, EmptyPlaceholderProps, Table, TableColumn, TableKey } from "@bridgesplit/ui";
import { EMPTY_STRING, SortOrder } from "@bridgesplit/utils";
import { DispatchType } from "@bridgesplit/react";

import { TableCardWrapper } from "./page";

export function PositionsTable<T>({
    items,
    columns,
    getRowKey,
    page,
    setPage,
    pageSize,
    totalCount,
    loading,
    emptyPlaceholder,
    header
}: {
    items: T[] | undefined;
    columns: TableColumn<T>[];
    getRowKey: (item: T) => TableKey;
    page: number;
    setPage: DispatchType<number>;
    pageSize: number;
    totalCount: number | undefined;
    loading?: boolean;
    emptyPlaceholder?: EmptyPlaceholderProps | string;
    header?: ReactNode;
}) {
    const rows = useMemo(() => (items ? createRows(items, getRowKey) : undefined), [items, getRowKey]);

    return (
        <Column spacing={2}>
            {header}
            <TableCardWrapper>
                <Table<T>
                    rows={rows}
                    columns={columns}
                    paginationProps={{
                        type: "api",
                        pageSize,
                        totalDataCount: totalCount,
                        controller: {
                            page,
                            setPage,
                            resetPage: () => setPage(0),
                            orderBy: EMPTY_STRING,
                            order: SortOrder.Desc
                        }
                    }}
                    loading={loading}
                    emptyPlaceholder={emptyPlaceholder}
                />
            </TableCardWrapper>
        </Column>
    );
}
